import * as React from 'react';

// The browser restores scroll while only the spinner shows and lands on the footer; restore it
// ourselves once content has loaded (as CoursePage does), on reload or back/forward only.
export function useScrollRestoredAfterLoad(storageKey: string, loaded: boolean) {
  const restoredRef = React.useRef(false)

  React.useEffect(() => {
    if (!('scrollRestoration' in window.history)) { return }
    window.history.scrollRestoration = 'manual'
    const saveScrollPosition = () => { window.sessionStorage.setItem(storageKey, String(window.scrollY)) }
    window.addEventListener('pagehide', saveScrollPosition)
    return () => {
      window.removeEventListener('pagehide', saveScrollPosition)
      window.history.scrollRestoration = 'auto'
    }
  }, [storageKey])

  React.useEffect(() => {
    if (!loaded || restoredRef.current) { return }
    restoredRef.current = true
    const savedPosition = window.sessionStorage.getItem(storageKey)
    window.sessionStorage.removeItem(storageKey)
    const navigationType = (window.performance?.getEntriesByType?.('navigation')[0] as PerformanceNavigationTiming | undefined)?.type
    if (savedPosition === null || !['reload', 'back_forward'].includes(navigationType)) { return }
    window.scrollTo(0, Number(savedPosition))
  }, [loaded, storageKey])
}
